// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingStressMusicIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={22} cy={22} r={22} fill="url(#OnboardingStressMusicIcon_tsx__a)" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.445 29.862c-.744.273-1.553.25-2.218-.06-.551-.257-.961-.693-1.154-1.228-.445-1.23.346-2.653 1.763-3.173.346-.126.706-.189 1.059-.189.406 0 .803.084 1.16.25.55.256.96.692 1.153 1.227.084.23.124.468.124.704v.003c.002 1.027-.736 2.045-1.887 2.466ZM17.091 14.518l13.241-2.072v2.927l-13.241 2.072v-2.927Zm-3.262 17.625c-.744.272-1.553.25-2.218-.06-.551-.257-.961-.693-1.154-1.228-.446-1.23.345-2.654 1.763-3.173.346-.126.705-.19 1.058-.19.406 0 .803.084 1.16.25.55.257.96.693 1.154 1.228.445 1.231-.346 2.654-1.763 3.173ZM31.433 11.16a.664.664 0 0 0-.537-.152L16.321 13.29a.667.667 0 0 0-.564.659v13.06a3.7 3.7 0 0 0-.756-.474c-.984-.459-2.165-.497-3.24-.104-2.105.771-3.253 2.96-2.558 4.88.315.87.97 1.574 1.844 1.981a4.082 4.082 0 0 0 1.724.374c.509 0 1.024-.09 1.516-.27 1.483-.543 2.487-1.789 2.711-3.149a.66.66 0 0 0 .093-.333V18.794l13.241-2.072v7.972a3.707 3.707 0 0 0-.714-.44c-.985-.46-2.166-.498-3.24-.105-2.106.772-3.253 2.96-2.56 4.88.316.87.97 1.574 1.845 1.981a4.082 4.082 0 0 0 1.725.374c.508 0 1.023-.09 1.515-.27 1.534-.56 2.555-1.875 2.73-3.288a.655.655 0 0 0 .033-.194V11.667a.667.667 0 0 0-.233-.507Z"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="OnboardingStressMusicIcon_tsx__a"
				x1={0}
				y1={0}
				x2={44}
				y2={44}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#9191FF" />
				<stop offset={1} stopColor="#F075C7" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingStressMusicIcon;
